import { usePermission } from '@/hooks/permissions'
import { ReactElement, useEffect } from 'react'
import toast from 'react-hot-toast'
import { Navigate, useLocation } from 'react-router-dom'

interface RequireNotViewOnlyProps {
  children: ReactElement
  redirectTo: string
}

/**
 * Component that prevents ViewOnly users from accessing certain routes
 */
const RequireNotViewOnly = ({
  redirectTo,
  children,
}: RequireNotViewOnlyProps) => {
  const { pathname: from } = useLocation()
  const { isViewOnly } = usePermission()

  useEffect(() => {
    if (isViewOnly) {
      toast.error('ViewOnly users cannot access admin pages!')
    }
  }, [isViewOnly])

  if (isViewOnly) {
    return <Navigate replace to={redirectTo} state={{ from }} />
  }

  return children
}

export default RequireNotViewOnly
